import { computed, unref, type MaybeRef } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import type { AxiosResponse } from 'axios';
import type { specialOffers } from 'shared';

import { api } from '@/shared/api';

export function getSpecialOffers({
  depCityCode,
}: {
  depCityCode: MaybeRef<string>;
}) {
  return {
    queryKey: ['special-offers', 'list', depCityCode],
    queryFn: () => api.specialOffers.list({ depCity: unref(depCityCode) }),
    staleTime: 5 * 60 * 1000,
  };
}

export function useSpecialOffers({
  depCityCode,
}: {
  depCityCode: MaybeRef<string>;
}) {
  const query = useQuery<AxiosResponse<specialOffers.Special[]>>(
    getSpecialOffers({ depCityCode }),
  );

  const specials = computed(() => query.data.value?.data ?? []);
  const isLoading = computed(() => query.isLoading.value);

  return { specials, isLoading };
}
